"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showScroll = exports.hideScroll = exports.getScrollBarWidth = void 0;
/**
 * Note: this will only return a width if the whole document has a scrollbar
 */
const getScrollBarWidth = () => {
    return window.innerWidth - document.body.offsetWidth;
};
exports.getScrollBarWidth = getScrollBarWidth;
const hideScroll = () => {
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = (0, exports.getScrollBarWidth)() + 'px';
};
exports.hideScroll = hideScroll;
const showScroll = () => {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
};
exports.showScroll = showScroll;
